import { connect } from 'react-redux';

import Agenda from '~/Components/Pages/Agenda/Agenda';

const mapStateToProps = ({ CalendarAccounts }) => {
  return {
    isFetching: CalendarAccounts.isFetching,
    isFetched: CalendarAccounts.isFetched,
    accounts: CalendarAccounts.data.filter(account => account.driver != 'PUBLIC_ICS').length,
  };
};

export default connect(mapStateToProps)(Agenda);
